export default "__VITE_ASSET__CFvgmGK9__"